<header
  class="bg-gray-100 py-5 shadow-[0_5px_5px_-5px] shadow-gray-200 sticky admin-navbar"
>
  <div class="flex justify-between items-center">
    <!-- Logo -->
    <div class="flex justify-start items-center px-10 ml-4">
      
    </div>

    <div class="flex justify-end items-center px-10 gap-x-1 mr-4">
      <div class="flex justify-end items-center gap-x-3">
        <div class="relative inline-block profile-dropdown" style="z-index: 9999;">
          
          <div class="flex items-center">
            <button
              type="button"
              (click)="toggleProfile($event)"
              class="flex w-10 h-10 overflow-hidden rounded-full border-2 border-orange-600 shadow mr-3"
            >
              <div class="relative inline-block w-full h-full">
                <div
                  class="text-xl text-light bg-gray-100 rounded-full w-full h-full flex items-center justify-center transition hover:bg-gray-300"
                >
                  <i class="bi bi-person text-orange-500"></i>
                </div>
              </div>
            </button>
            <div class="pointer" (click)="toggleProfile($event)">
              <div class="text-black font-medium">
                <span>{{ currentUser.nom + " " + currentUser.prenoms }}</span>
              </div>
              <div class="text-orange-500">
                <span>{{ currentUser.profil }}</span>
              </div>
            </div>
          </div>

          <!-- Menu déroulant du profil -->
          <div
            *ngIf="isProfileOpen"
            class="profile-dropdown-list"
            (click)="$event.stopPropagation()"
            style="z-index: 99999 !important; position: fixed !important;"
          >
            <!-- Section d'informations de l'utilisateur -->
            <div class="flex gap-3 items-center py-4 px-4">
              <div class="flex items-center justify-start gap-x-3">
                <div class="relative inline-block">
                  <div
                    class="text-2xl text-light rounded-full w-full h-full flex items-center justify-center transition hover:bg-gray-300"
                  >
                    <i class="bi bi-person text-orange-500"></i>
                  </div>
                </div>
                
                <div>
                  <div class="flex gap-1 text-sm font-semibold">
                    <span>{{ currentUser.nom + " " + currentUser.prenoms }}</span>
                    <span class="text-emerald-600">
                      <i class="bi bi-check2-circle"></i>
                    </span>
                  </div>
                  <div class="text-xs text-slate-400">{{ currentUser.email }}</div>
                </div>
              </div>
            </div>

            <!-- Séparateur -->
            <div class="border-t border-slate-500/30"></div>

            <!-- Options du menu -->
            <div class="flex flex-col text-sm p-2">
              <a
                (click)="openChangePasswordModal()"
                class="flex items-center gap-3 rounded-md p-2 hover:bg-slate-200 cursor-pointer"
                style="z-index: inherit;"
              >
                <i class="bi bi-key-fill"></i>
                <span>Changer mon mot de passe</span>
              </a>
            </div>

            <!-- Séparateur -->
            <div class="border-t border-slate-500/30"></div>
            <!-- Options du menu -->
            <div class="flex flex-col text-sm p-2">
              <a
                href="#"
                class="flex items-center gap-3 rounded-md p-2 hover:bg-slate-200"
                style="z-index: inherit;"
              >
                <i class="bi bi-file-earmark-arrow-down"></i>
                <span>Télécharger le manuel</span>
              </a>
            </div>

            <!-- Séparateur -->
            <div class="border-t border-slate-500/30"></div>

            <!-- Bouton de déconnexion -->
            <div class="p-3">
              <button
                type="button"
                (click)="onDeconnected()"
                class="w-full p-2 text-left text-sm text-red-400 font-semibold rounded transition hover:bg-slate-200"
                style="z-index: inherit;"
              >
                <i class="bi bi-power mr-2"></i>
                Déconnexion
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>

@if (showPasswordModal) {
  <div
    class="fixed inset-0 z-[10000] flex items-center justify-center p-4 bg-black/50"
    style="z-index: 10000 !important;"
  >
    <div class="relative bg-white w-full max-w-md shadow-xl overflow-hidden">
   
      <div class="px-6 py-4 bg-black flex justify-between items-center">
        <h1 class="text-xl font-semibold text-white">
          Modification du mot de passe
        </h1>
        <button
          (click)="closePasswordModal()"
          class="text-white hover:text-orange-500 transition-colors"
        >
          <i class="bi bi-x-lg text-xl"></i>
        </button>
      </div>
  
      <form [formGroup]="changePassword" (ngSubmit)="confirmSave()">
        <div class="p-6 space-y-4">
          <div class="form-group">
            <label class="block text-sm font-medium text-gray-700 mb-1">
              Email
            </label>
            <input 
              formControlName="email"
              class="w-full h-11 border bg-white px-4 py-2 appearance-none"
              readonly
            />
          </div>
  
          <div class="form-group relative">
            <label class="block text-sm font-medium text-gray-700 mb-1">
              Ancien mot de passe
            </label>
            <div class="relative">
              <input
                [type]="hidePassword ? 'password' : 'text'"
                formControlName="oldMotDePasse"
                class="w-full h-11 border bg-white px-4 py-2 pr-10 appearance-none"
                [ngClass]="{
                  'border-red-500': hasError('oldMotDePasse', 'required')
                }"
                placeholder="Entrez votre ancien mot de passe"
              />
              <button
                type="button"
                class="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-600 hover:text-orange-500 transition-colors"
                (click)="togglePasswordVisibility()"
              >
                <i class="bi" [ngClass]="hidePassword ? 'bi-eye-slash' : 'bi-eye'"></i>
              </button>
            </div>
            @if (hasError('oldMotDePasse', 'required')) {
              <div class="text-red-500 text-xs mt-1">
                L'ancien mot de passe est requis
              </div>
            }
          </div>
  
          <div class="form-group relative">
            <label class="block text-sm font-medium text-gray-700 mb-1">
              Nouveau mot de passe
            </label>
            <div class="relative">
              <input
                [type]="hideNewPassword ? 'password' : 'text'"
                formControlName="motDePasse"
                class="w-full h-11 border bg-white px-4 py-2 pr-10 appearance-none"
                [ngClass]="{
                  'border-red-500':
                    hasError('motDePasse', 'required') ||
                    hasError('motDePasse', 'minlength')
                }"
                placeholder="Entrez votre nouveau mot de passe"
              />
              <button
                type="button"
                class="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-600 hover:text-orange-500 transition-colors"
                (click)="toggleNewPasswordVisibility()"
              >
                <i class="bi" [ngClass]="hideNewPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
              </button>
            </div>
            @if (hasError('motDePasse', 'required')) {
              <div class="text-red-500 text-xs mt-1">
                Le nouveau mot de passe est requis
              </div>
            }
            @if (hasError('motDePasse', 'minlength')) {
              <div class="text-red-500 text-xs mt-1">
                Le mot de passe doit contenir au moins 8 caractères
              </div>
            }
          </div>
        </div>
        <div class="px-6 py-4 bg-gray-50 flex justify-end gap-3 border-t">
          <button
            type="button"
            (click)="closePasswordModal()"
            class="px-6 py-2 bg-gray-900 text-white rounded hover:bg-gray-800 w-full md:w-auto"
          >
            Annuler
          </button>
          <button
            type="submit"
            class="px-6 py-2 bg-orange-500 text-white rounded hover:bg-orange-600 w-full md:w-auto"
          >
            Enregistrer
          </button>
        </div>
      </form>
    </div>
  </div>
}